import axios from "axios";
const BASE_URL = "https://api.shipperswise.com";

export const trackShipment = async (shipmentId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/track-shipment?shipment_id=${shipmentId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error);
  }
};
